import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { search } from '../../api/searchService';
import './Search.scss';
import Icon from '../../components/Icons/Icon';

const Search = () => {
  const [searchParams] = useSearchParams();
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const searchTerm = searchParams.get('q') || '';

  useEffect(() => {
    const performSearch = async () => {
      if (!searchTerm) {
        setSearchResults([]);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await search(searchTerm);

        if (response.isSuccess) {
          setSearchResults(response.data || []);
        } else {
          setError(response.resultMessage || 'Arama sırasında bir hata oluştu');
          setSearchResults([]);
        }
      } catch (error) {
        setError('Arama sırasında bir hata oluştu');
        setSearchResults([]);
      } finally {
        setLoading(false);
      }
    };

    performSearch();
  }, [searchTerm]);

  const handleResultClick = (result) => {
    switch (result.type) {
      case 'News':
        navigate(`/haberler/${result.urlTag}`);
        break;
      case 'Announcements':
        navigate(`/duyurular/${result.urlTag}`);
        break;
      case 'Events':
        navigate(`/etkinlikler/${result.urlTag}`);
        break;
      case 'Tenders':
        navigate(`/ihaleler/${result.urlTag}`);
        break;
      default:
        console.warn('Unknown result type:', result.type);
    }
  };

  const getIconForType = (type) => {
    switch (type) {
      case 'News':
        return 'news';
      case 'Announcements':
        return 'duyuru';
      case 'Events':
        return 'calendar';
      case 'Tenders':
        return 'forms';
      default:
        return 'file';
    }
  };

  const getTypeText = (type) => {
    switch (type) {
      case 'News':
        return 'Haber';
      case 'Announcements':
        return 'Duyuru';
      case 'Events':
        return 'Etkinlik';
      case 'Tenders':
        return 'İhale';
      default:
        return type;
    }
  };

  return (
    <div className="search-page">
      <div className="container">
        <div className="search-header">
          <h1>Arama Sonuçları</h1>
          {searchTerm && <p>"{searchTerm}" için arama sonuçları</p>}
        </div>

        <div className="search-content">
          {loading ? (
            <div className="loading">
              <Icon icon="loading" className="spin" />
              <span>Aranıyor...</span>
            </div>
          ) : error ? (
            <div className="error-message">
              <Icon icon="error" />
              <span>{error}</span>
            </div>
          ) : searchResults.length === 0 ? (
            <div className="no-results">
              <Icon icon="search" />
              <p>Sonuç bulunamadı.</p>
              {searchTerm && <p>Farklı anahtar kelimeler deneyebilirsiniz.</p>}
            </div>
          ) : (
            <div className="search-results">
              {searchResults.map((result) => (
                <div
                  key={result.guid}
                  className="search-result-item"
                  onClick={() => handleResultClick(result)}
                >
                  <div className="result-icon">
                    <Icon icon={getIconForType(result.type)} />
                  </div>
                  <div className="result-content">
                    <p className="result-description">{result.description}</p>
                    <span className="result-type">{getTypeText(result.type)}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Search;
